import internationalInstitutionsJson from './international_institutions.json';
import nationalInstitutionsJson from './national_institutions.json';

export const otherInstitutionsOption: string = 'Otras Instituciones';

export const nationalInstitutions: string[] = Array.from(
  new Set(nationalInstitutionsJson.concat([otherInstitutionsOption]))
);

export const internationalInstitutions: string[] = Array.from(
  new Set(internationalInstitutionsJson.concat([otherInstitutionsOption]))
);
